import { useEffect, useState } from 'react';
import {
  useCart,
  useCartTotals,
  useSettings,
  useProductByHandle,
  useCartAddItem,
  useCartRemoveItem,
  useCountry,
} from '@backpackjs/storefront';
import Cookies from 'js-cookie';
import { getSizedImageUrl } from '../../utilities/Images';
import { IconRemove } from '..';

export function FreeSampleItems() {
  const cart = useCart();
  const cartTotals = useCartTotals();
  const siteSettings = useSettings();
  const { cartAddItem } = useCartAddItem();
  const { cartRemoveItem } = useCartRemoveItem();
  const optedOut = Cookies.get('free-samples_opted-out') || false;

  const { country } = useCountry();
  const countryCode = country?.isoCode || 'US';
  const isUs = countryCode === 'US';

  const { samplesProduct, samplesCartMinimum, freeSamplesAddBack } = {
    ...siteSettings?.freeProducts?.sampleSettings,
  };
  const { product } = useProductByHandle({ handle: samplesProduct?.handle });
  const cartTotal = parseFloat(cartTotals?.total);

  const samplesLine = cart?.lines.find(
    (line) => line?.variant?.product?.handle === product?.handle
  );

  const samplesInCart = !!samplesLine;

  const addSamples = async () => {
    if (product?.variants?.[0]?.id) {
      await cartAddItem({
        merchandiseId: product?.variants?.[0]?.id,
        quantity: 1,
        attributes: [{ key: '_sample', value: 'true' }],
      });
    }
  };

  const removeSamples = async () => {
    if (samplesLine?.id) {
      await cartRemoveItem({ lineId: samplesLine?.id });
    }
  };

  useEffect(() => {
    // free samples offset with timeout to avoid conflict with GWP
    if (cartTotal >= samplesCartMinimum && !samplesInCart && isUs && !optedOut) {
      setTimeout(() => {
        addSamples();
      }, 750);
    }
    if (cartTotal < samplesCartMinimum && samplesInCart) {
      setTimeout(() => {
        removeSamples();
      }, 750);
    }
  }, [cartTotal, cart?.lines?.length, isUs]);

  if (
    !samplesCartMinimum ||
    !samplesProduct ||
    !product ||
    !isUs ||
    cartTotal < samplesCartMinimum
  )
    return null;

  if (optedOut) {
    return (
      <div className="line-item-add-sample relative flex items-center justify-between border-b border-grey-4 py-5 px-4">
        <button
          type="button"
          className="border-b-2 font-gothamBold text-sm"
          onClick={() => {
            Cookies.remove('free-samples_opted-out');
            addSamples();
          }}
        >
          {freeSamplesAddBack}
        </button>
      </div>
    );
  };

  if (!samplesLine) return null;

  return (
    <div className="free-samples free-sample-line-item-container relative flex items-center justify-between border-b border-grey-4 py-5 px-4">
      <div className="w-20 shrink-0">
        <img
          src={getSizedImageUrl(samplesLine?.variant?.image?.src, '100x100@2x')}
          alt={samplesLine?.variant?.product?.title}
        />
      </div>
      <button
        className="z-1 absolute right-4 top-5 inline-block cursor-pointer"
        onClick={() => {
          Cookies.set('free-samples_opted-out', true);
          removeSamples();
        }}
        type="button"
      >
        <IconRemove />
      </button>
      <div className="relative flex-grow pl-3">
        <div className="my-0 inline-block pr-8 font-gothamBold text-xs no-underline">
          {samplesLine?.variant?.product?.title}
        </div>
        <p className="mt-0 mb-0 text-xs lg:mt-1">one-time purchase</p>
        <div className="mt-6 flex items-center justify-between">
          <span />
          <div className="text-right font-gothamBold text-sm">FREE</div>
        </div>
      </div>
    </div>
  );
}

export default FreeSampleItems;
